import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AutomotiveAppFuel1,
  AutomotiveAppFuel2,
  AutomotiveAppFuel3,
  AutomotiveAppFuel4,
  AutomotiveAppFuel5,
  AutomotiveAppFuel6,
} from "../../../../app-constants-updated";

function Fuelservices() {
  return (
    <section className="fuel_services p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Fuel Your Success with <span> Advanced Automotive App </span>
              Performance
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="fuel-main">
              <div className="fuel-main-item">
                <div className="fuel-img">
                  {AutomotiveAppFuel1}
                  <div className="fuel-content">
                    <h5>55%</h5>
                    <p>Growth in Customer Retention</p>
                  </div>
                </div>
              </div>
              <div className="fuel-main-item">
                <div className="fuel-img">
                  {AutomotiveAppFuel2}
                  <div className="fuel-content">
                    <h5>68%</h5>
                    <p>Increase in Fleet Management Efficiency</p>
                  </div>
                </div>
              </div>
              <div className="fuel-main-item">
                <div className="fuel-img">
                  {AutomotiveAppFuel3}
                  <div className="fuel-content">
                    <h5>50%</h5>
                    <p>Reduction in Vehicle Downtime</p>
                  </div>
                </div>
              </div>
              <div className="fuel-main-item">
                <div className="fuel-img">
                  {AutomotiveAppFuel4}
                  <div className="fuel-content">
                    <h5>40%</h5>
                    <p>Decrease in Fuel Consumption</p>
                  </div>
                </div>
              </div>
              <div className="fuel-main-item">
                <div className="fuel-img">
                  {AutomotiveAppFuel5}
                  <div className="fuel-content">
                    <h5>47%</h5>
                    <p>Boost in Sales Conversion</p>
                  </div>
                </div>
              </div>
              <div className="fuel-main-item">
                <div className="fuel-img">
                  {AutomotiveAppFuel6}
                  <div className="fuel-content">
                    <h5>38%</h5>
                    <p>Decline in Operational Costs</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Fuelservices;
